import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/routing/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import JobsListPage from './pages/jobs/JobsListPage';
import JobDetailPage from './pages/jobs/JobDetailPage';
import StoreServicePage from './pages/jobs/StoreServicePage';
import ProductServicePage from './pages/jobs/ProductServicePage';
import StoreSubmitPage from './pages/jobs/StoreSubmitPage';
import ViewProductRecordPage from './pages/jobs/ViewProductRecordPage';
import NotFoundPage from './pages/NotFoundPage';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/jobs" replace />} />
          <Route path="jobs" element={<JobsListPage />} />
          <Route path="jobs/:jobId" element={<JobDetailPage />} />
          <Route path="jobs/:jobId/store/:storeId/products" element={<StoreServicePage />} />
          <Route path="jobs/:jobId/store/:storeId/product/:productId" element={<ProductServicePage />} />
          <Route path="jobs/:jobId/store/:storeId/product/:productId/view" element={<ViewProductRecordPage />} />
          <Route path="jobs/:jobId/store/:storeId/submit" element={<StoreSubmitPage />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
